export const orgKeys = {
  all: ['organization'] as const,
  current: () => ['current-organization'] as const,
  userOrgs: () => ['user-organizations'] as const,
  currentRole: (orgId?: string | null) => ['current-user-role', orgId ?? 'none'] as const,
  userRole: (orgId?: string | null) => ['user-role', orgId ?? 'none'] as const,
  teamMembers: (orgId: string) => ['team-roles', orgId] as const,
  userManagement: (orgId: string) => ['user-management', orgId] as const,
  userInvitations: (orgId?: string | null) => ['user-invitations', orgId ?? 'all'] as const,
  legacyUserInvitations: () => ['user-invitations'] as const,
  legacyTeamRoles: () => ['team-roles'] as const,
};
